import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { CommunicationService } from '../../../services/communication.service';
import { ViewModes, ListingCategory } from '../../../classes/enums';
import {HasSubscriptions} from '../../has-subscriptions';

@Component({
  selector: 'app-sub-nav',
  templateUrl: './sub-nav.component.html',
  styleUrls: ['./sub-nav.component.scss']
})
export class SubNavComponent extends HasSubscriptions implements OnInit {
  @Input() activeViewMode: ViewModes = ViewModes.MAP;
  @Input() currentShownListingType: ListingCategory;

  @Output() filterClick: EventEmitter<void> = new EventEmitter();
  @Output() saveSearchClick: EventEmitter<void> = new EventEmitter();
  @Output() viewModeClick: EventEmitter<void> = new EventEmitter();
  showShare: boolean = false;
  showSearch: boolean = false;

  // Enums:
  ViewModes = ViewModes;
  ListingCategory = ListingCategory;
  constructor(private communicationService: CommunicationService) {
    super();
  }

  ngOnInit() {
    // reacts to when the user clicks on the button to hide the search bar
    this.addSub(this.communicationService.navigation.showSearch.subscribe((showSearch) => {
      this.showSearch = showSearch;
    }))
  }

  toSearch() {
    this.showSearch = !this.showSearch;
    this.communicationService.navigation.showSearch.next(this.showSearch);
  }

}
